export class CrescimentoAlturaIncompativelMessageStrategy {
	constructor(alturaAnterior, alturaAtual) {
		console.log(typeof alturaAnterior)
		this.alturaAnterior = alturaAnterior
		this.alturaAtual = alturaAtual
	}

	get short() {
		return { message: 'Crescimento da altura é incompatível' }
	}

	get long() {
		const message =
			this.alturaAnterior > this.alturaAtual
				? `A altura coletada atual (${this.formattedCurrentHeight}m) é menor que a coletada no inventário anterior (${this.formattedPreviousHeight}m)`
				: `A altura coletada atual (${this.formattedCurrentHeight}m) é maior que a coletada no inventário anterior (${this.formattedPreviousHeight}m)`
		const title =
			this.alturaAnterior > this.alturaAtual
				? 'HT atual é menor que HT do inventário anterior'
				: 'HT atual é maior que HT do inventário anterior'
		return { message, title }
	}

	get formattedPreviousHeight() {
		return Number(this.alturaAnterior).toFixed(2)
	}

	get formattedCurrentHeight() {
		return Number(this.alturaAtual).toFixed(2)
	}
}
